import LogoImg from 'assets/img/new-logo.svg';
import NovembroAzul from 'assets/img/campanhas/laco-azul.png';

const Logo = () => {
  return (
    <div className="relative">
      <span className="absolute right-[-3.125%] top-[-6.56%] w-[22.56%] pointer-events-none">
        <img src={NovembroAzul} alt="" />
      </span>
      <img src={LogoImg} alt="#JogaJunto BB" />
    </div>
  );
};

export default Logo;
